/**
 * Created by kachavas on 6/23/16.
 */
angular
  .module('data-ng-todos')
  .constant('PathTasksVisibilityDTD', {
    task: {
      type: 'object',
      typeDef: {
        id: 'id',
        event: 'id',
        repeated_by: 'id',
        show: 'boolean'
      }
    }
  })
  .provider('pathTasksVisibilityModel', function pathTasksVisibilityModel(PathTasksVisibilityDTD) {
    'use strict';

    var PathTasksVisibilityModel = function PathTasksVisibilityModel(Interface) {
      this.initialize = function initialize() {
        Interface.implement(PathTasksVisibilityDTD, {}, this);
        return this;
      };
      this.update = function update(data) {
        Interface.implement(PathTasksVisibilityDTD, data, this);
        return this;
      };
      this.clear = function clear() {
        this.task = {};
      };
    };

    this.$get = function $get_pathTasksVisibilityModel(Interface) {
      return new PathTasksVisibilityModel(Interface).initialize();
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/models/path_task_visibility_status_model.js